import { type ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'info' | 'violet';

export interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-[#f5f5f5] text-[#666]',
  success: 'bg-[#e8f5e9] text-[#2e7d32]',
  warning: 'bg-[#fff3e0] text-[#e65100]',
  error: 'bg-[#ffebee] text-[#c62828]',
  info: 'bg-[#e3f2fd] text-[#1565c0]',
  violet: 'bg-[#f3e8ff] text-[#6d28d9]',
};

export function Badge({ variant = 'default', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-block rounded-[10px] px-2.5 py-0.5 text-[11px] font-semibold tracking-[0.3px]',
        variantClasses[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
